import React from "react";

import useTranslatedText from "components/use-hooks/use-translated-text";


const TranslatedText = ({
        text,
        fallback = "",
        namespace,
        context,
        sourceLang
    }) => {
    const translatedText = useTranslatedText(text, {
        namespace,
        context,
        sourceLang
    });

    return <>{ translatedText || fallback }</>;
};

export default TranslatedText;
